import client from './apiErpConnector';

async function getRolesByDestination(destinationId, user = false) {
  if (user) {
    return client().get(`/destinations/${destinationId}/roles`, { params: { start: 0, size: 999 } });
  }
  return client().get(`/destinations/${destinationId}/clientroles`, { params: { start: 0, size: 999 } });
}

export default {
  getRolesByDestination,
};
